import React, { memo } from 'react'
import { Footer } from './Footer'


export const Hackatons = () => {
  return (
    <div>Hackatons


    
    </div>
  )
}
